import { useUserMe } from '@/hooks/useUserMe';
import { useLimitedAccessOrganization } from '@/pages/shared/hooks/useLimitedAccessOrganization';
import { useOrganizationId } from '@/pages/shared/hooks/useOrganizationId';

export const useIsLimitedAccessUser = () => {
  const user = useUserMe().data;
  const organizationId = useOrganizationId();
  const limitedAccessOrganizations = useLimitedAccessOrganization(organizationId, { user_id: user.id }).data;
  return limitedAccessOrganizations && limitedAccessOrganizations.length > 0;
};
